<router-outlet></router-outlet>
<div id="version">
  {{ COMMIT_SHORT_SHA }}
</div>
